import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { BillingConceptListService } from '../../service/billing-concept-list/billing-concept-list.service';

@Component({
	selector: 'app-billing-concept-list',
	templateUrl: './billing-concept-list.component.html',
	providers: [
		BillingConceptListService,
		HttpModule
	]
})

export class BillingConceptListComponent implements OnInit {
	private token;
	public conceptbillings: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	bilingConcept: FormGroup;

	constructor(fb: FormBuilder, private billingconceptListService: BillingConceptListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.bilingConcept = fb.group({
			'Nome': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.searchConceptBilling(this.bilingConcept.value, 0, false);
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchConceptBilling(this.bilingConcept.value, this.currentPage, false);
	}

	searchConceptBilling(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.billingconceptListService.searchConceptBilling(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.conceptbillings = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchConceptBilling(this.bilingConcept.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/billing-concept/component/billing-concept-list/billing-concept-list.component.ts